import { createContext, useContext } from 'react';
import { ActivityStore } from './activityStore';
import { CommonStore } from './commonStore';
import { UserStore } from './userStore';
import { ModalStore } from './modalStore';
import { ProfileStore } from './profileStore';
import { CommentStore } from './commentStore';

interface Store {
  activityStore: ActivityStore;
  commonStore: CommonStore;
  userStore: UserStore;
  modalStore: ModalStore;
  profileStore: ProfileStore;
  commentStore: CommentStore;
}

const store: Store = {
  activityStore: new ActivityStore(),
  commonStore: new CommonStore(),
  userStore: new UserStore(),
  modalStore: new ModalStore(),
  profileStore: new ProfileStore(),
  commentStore: new CommentStore(),
};

const StoreContext = createContext(store);

const useStore = () => {
  return useContext(StoreContext);
};

export { store, StoreContext, useStore };
